import { Component } from '@angular/core';
import { RouteManager } from '../../managers/route.manager';
import { RouteEnum } from '../../enums/route.enum';

@Component({
  selector: 'app-error-404',
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.scss',
  standalone: false,
})
export class Error404Component {
  protected readonly RouteEnum = RouteEnum;

  constructor(
    public readonly routeManager: RouteManager,
  ) {
  }
}
